<p>
  callback works!
</p>
<div class="loading">
  <img src="assets/loading.svg" alt="loading">
</div>
